export default {"src":"/_next/static/media/envelope-classic-solid.1c24761f.svg","height":24,"width":24};